<template>
  <b-container> 
    <pendencies-expired :moduleId="moduleId"></pendencies-expired>
  </b-container>
</template>
<script>
export default {
  name: "ModulePendenciesExpired",
  props:{
    moduleId: String
  },
  components: {
    PendenciesExpired: () => import("src/pagesRms/checklist/pendency/PendenciesExpired.vue")
  },
};
</script>
